import React, { useState } from 'react';
import cx from 'classnames';

import logo from '../../images/h_logo.svg';
import './Header.scss';
import Hamburger from '../Hamburger';
import Sidebar from '../Sidebar/Sidebar';
import { useRouteMatch } from 'react-router-dom';

const Header = ({ isHome }) => {
  const [isSticky] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const matchSummary = useRouteMatch('/:tipo/:modelo/:version/:anio/:color/resumen/');

  const closeSidebar = () => {
    setSidebarOpen(false);
    document.body.classList.remove('App--no-scroll');
  };

  const openSidebar = () => {
    setSidebarOpen(true);
    document.body.classList.add('App--no-scroll');
  };

  return (
    <>
      <div className={cx('header', { 
        'header--sticky': isSticky, 
        'header--is-not-home': !isHome, 
        'header--is-summary': matchSummary?.isExact }
        )}>
        <a href="/">
          <img className="header__logo" src={logo} alt="Logo" />
        </a>
        <Hamburger onClick={() => openSidebar()} />
        
      </div>
      {sidebarOpen && <Sidebar onClose={() => closeSidebar()} />}
    </>
  );
};

export default Header;
